import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.25 7C4.25 4.79086 6.04086 3 8.25 3C10.4591 3 12.25 4.79086 12.25 7C12.25 9.20914 10.4591 11 8.25 11C6.04086 11 4.25 9.20914 4.25 7Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.25 7C13.25 4.79086 15.0409 3 17.25 3C19.4591 3 21.25 4.79086 21.25 7C21.25 9.20914 19.4591 11 17.25 11C15.0409 11 13.25 9.20914 13.25 7Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.24974 12C11.1205 12 13.8436 13.9807 14.8571 17.6135C15.3871 19.5131 13.767 21 12.1038 21H4.39569C2.73253 21 1.11242 19.5131 1.64235 17.6135C2.65586 13.9807 5.37896 12 8.24974 12Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.7844 17.0761C16.2965 15.3276 15.4579 13.8486 14.3799 12.7021C15.2754 12.2386 16.254 12 17.2505 12C20.1212 12 22.8443 13.9807 23.8578 17.6135C24.3878 19.5131 22.7677 21 21.1045 21H16.0807C16.8487 19.9549 17.1995 18.5641 16.7844 17.0761Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }